import { jsx as _jsx } from "react/jsx-runtime";
import { useIsLoggedInRetailer } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { getIsAppInstalled } from "@faire/retailer-visitor-shared/serialized-data/getIsAppInstalled";
import { useAssignSettingNuxAppDownloadNudges, useSettingNuxAppDownloadNudges } from "@faire/retailer-visitor-shared/settings/useSettingNuxAppDownloadNudges";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { MobileAppSnackbarWrapper } from "@faire/retailer-visitor-shared/components/App/MobileAppSnackbarWrapper";
import { AppDownloadNudgeWrapper } from "@faire/retailer-visitor-shared/components/AppDownloadNudge/AppDownloadNudgeWrapper";
import { isAppDownloadPath } from "@faire/retailer-visitor-shared/app/_lib/wrappers/appDownloadWrapperUtils";
export var AppDownloadWrapper = function() {
    var pathname = useLocation().pathname;
    var isMobile = useViewport().isMobile;
    var isLoggedInRetailer = useIsLoggedInRetailer();
    var isNuxAppDownloadNudgesEnabled = useSettingNuxAppDownloadNudges();
    var assignSettingNuxAppDownloadNudges = useAssignSettingNuxAppDownloadNudges();
    var shouldAssign = isMobile && isLoggedInRetailer && !getIsAppInstalled() && isAppDownloadPath(pathname);
    useEffect(function() {
        if (shouldAssign) {
            assignSettingNuxAppDownloadNudges();
        }
    }, [
        assignSettingNuxAppDownloadNudges,
        shouldAssign
    ]);
    return isNuxAppDownloadNudgesEnabled ? /*#__PURE__*/ _jsx(AppDownloadNudgeWrapper, {}) : /*#__PURE__*/ _jsx(MobileAppSnackbarWrapper, {});
};
